<template>
  <iframe
    v-if="videoUrl"
    :width="$vuetify.breakpoint.xs ? '100%' : 640"
    height="390"
    :src="'https://' + videoUrl"
    frameborder="0"
    title="YouTube video player"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  />
</template>
<script>
export default {
  name: "MediaTpl",

  props: {
    content: { type: String, required: true }
  },
  data() {
    return {
      parsedContent: null,
      videoUrl: null,
      error: null
    };
  },
  mounted() {
    this.handleParsedContent();
  },
  methods: {
    // Adds https:// when a URL is protocol-relative (starts with "//")
    // or has no protocol at all (e.g. "www.youtube.com/...").
    normalizeProtocol(url) {
      if (!url || typeof url !== "string") return url;

      const trimmed = url.trim();

      // Protocol-relative: //www.youtube.com/...
      if (trimmed.startsWith("//")) {
        return `https:${trimmed}`;
      }

      // Already has a protocol (http:, https:, etc.)
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) {
        return trimmed;
      }

      // No protocol at all: www.youtube.com/... or youtube.com/...
      return `https://${trimmed}`;
    },

    handleParsedContent() {
      if (typeof this.content == "string") {
        this.videoUrl = this.content;
      } else {
        this.parsedContent = JSON.parse(this.content);
        try {
          this.error = null;

          // Normalize once, right after parsing, so every branch below
          // works with a well-formed absolute URL.
          const rawUrl = this.normalizeProtocol(this.parsedContent.url);
          this.parsedContent.url = rawUrl;
          this.videoUrl = rawUrl;

          // YOUTUBE
          if (rawUrl.search("youtube.com") > -1) {
            // LINK DIRETTO (watch)
            if (rawUrl.search("watch?") > -1) {
              this.videoUrl = rawUrl.replace("watch?v=", "embed/");
            } else {
              // LINK PER EMBED (embed)
              this.videoUrl = rawUrl;
            }
          }

          // VIMEO
          if (
            rawUrl.search("https://player.vimeo.com/video") < 0 &&
            rawUrl.search("vimeo.com") > -1
          ) {
            // LINK DIRETTO da convertire in URL per embed
            let decodedUrl = new URL(rawUrl);
            if (decodedUrl) {
              this.videoUrl = `https://player.vimeo.com/video${decodedUrl.pathname}`;
            } else {
              this.error = this.$t("errors.errorParsingVideoUrl");
            }
          }
        } catch (error) {
          console.log(error);
          this.error = error || this.$t("errors.errorParsingVideoUrl");
        }
      }
    }
  }
};
</script>
